import React, { useEffect, useState } from 'react';
import { firestore } from './firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import './EventsOutput.css';

const EventsOutput = () => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      const eventsCollection = collection(firestore, 'events');
      const eventsSnapshot = await getDocs(eventsCollection);
      setEvents(eventsSnapshot.docs.map((doc) => doc.data()));
    };

    fetchEvents();
  }, []);

  return (
    <div className="events-container">
      <h2>Events</h2>
      {events.length === 0 ? (
        <p>No events added yet.</p>
      ) : (
        <ul className="events-list">
          {events.map((event, index) => (
            <li key={index} className="event-item">
              <div className="event-content">
                <div className="event-images">
                  {event.imageUrls && event.imageUrls.length > 0 ? (
                    <Carousel images={event.imageUrls} />
                  ) : (
                    <p>No images available.</p>
                  )}
                </div>
                <div className="event-details">
                  <div className="event-header">
                    <h3 className="event-name">{event.name}</h3>
                    <p className="event-date">{event.date}</p>
                  </div>
                  <p className="event-description">{event.description}</p>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const Carousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="carousel">
      <button className="carousel-control prev" onClick={prevSlide}>
        &#10094;
      </button>
      <div className="carousel-images">
        <img src={images[currentIndex]} alt={`Slide ${currentIndex}`} />
      </div>
      <button className="carousel-control next" onClick={nextSlide}>
        &#10095;
      </button>
    </div>
  );
};

export default EventsOutput;
